let loadPromise;

export const isGoogleMapsLoaded = () => Boolean(window.google?.maps?.places);

export const loadGoogleMaps = () => {
  if (isGoogleMapsLoaded()) {
    return Promise.resolve();
  }

  if (loadPromise) {
    return loadPromise;
  }

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  if (!apiKey) {
    return Promise.reject(new Error('REACT_APP_GOOGLE_MAPS_KEY is not set'));
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Google Maps'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};
